import sanitizeHtml from 'sanitize-html'

import { IAttachment, IFileDataCrud } from 'clickNgo/models/file'
import { getAccessToken } from 'cng-common/helpers/access'
import { proxy } from 'core/classes/helpers/UrlHelper'

import { createLegalFileRecord } from './createLegalFileRecord'
import { deleteAttachments } from './deleteAttachments'

export interface IUploadAttachments {
  partnerId: string
  attachments: IAttachment[]
}

interface IUploadAttachment {
  attachment: IAttachment
  token: string | null
}

export const uploadAttachments = async ({
  partnerId,
  attachments,
}: IUploadAttachments): Promise<IAttachment[]> => {
  const token = getAccessToken()

  const records = new Array(attachments.length).fill({ PartnerId: partnerId, Type: 'legal' })
  if (records.length > 0) {
    const newAttachments = await createLegalFileRecord(records).then(
      (fileRecords: IFileDataCrud[]) => {
        return fileRecords.map((fileRecord, recIndex) => ({
          ...attachments[recIndex],
          entryId: fileRecord.EntryId,
        }))
      }
    )

    const rawResult = await Promise.all(
      newAttachments.map(async (attachment) => await upload({ attachment, token }))
    )

    return rawResult.filter((result) => result !== null) as IAttachment[]
  }

  return []
}

const upload = async ({ attachment, token }: IUploadAttachment) => {
  const { entryId, fieldName, file, fileName, formId } = attachment

  if (!fileName || !file) {
    return null
  }

  const url = proxy(`/form/${formId}/attachments/${entryId}/${fieldName}/handler`)
  const data = new FormData()

  data.append('Attachment', 'Attachment')
  data.append(fieldName, file, fileName)

  const result = await fetch(sanitizeHtml(url), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    method: 'POST',
    body: data,
  })

  if (!result.ok) {
    await deleteAttachments([attachment])
    return null
  }

  return attachment
}
